import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { resources as Employers } from "./Employers";
import { resources as Jobs } from "./Jobs";

import { tenants } from "utils/tenants";
//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <BusinessCenterIcon />,
  name: "Кариерен център",
  title: "Кариерен център",
  subMenu: [Employers, Jobs],
};
